import { clone } from "../../utils";
import moment from "moment";

export function castQuoteFromDb(quote){
    let clonedQuote = clone(quote);
    clonedQuote.date_start = moment(clonedQuote.date_start);
    clonedQuote.date_end = moment(clonedQuote.date_end);
    clonedQuote.date_signed = moment(clonedQuote.date_signed);
    return clonedQuote;
}

export function adaptQuoteForMyOpen(quote) {
    let newQuote = clone(quote);
    newQuote.date_start = moment(newQuote.date_start);
    newQuote.date_end = moment(newQuote.date_end);
    newQuote.date_signed = moment(newQuote.date_signed);
    newQuote.created_affair_id = newQuote.created_affair_id ? newQuote.created_affair_id : null;
    return newQuote;
}

export function adaptQuoteForOpenERP(quote) {
    quote = clone(quote);
    
    return quote;
}
